// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26tIY","colMin":"styles_colMin__T8As9"};